import { jsx as _jsx } from "react/jsx-runtime";
import { getTestId } from '@airtel/air-design-system';
import DOMPurify from 'dompurify';
import HTMLReactParser from 'html-react-parser';
import { View } from 'react-native';
import { getDescriptionWidgetStyles } from './DescriptionWidgetStyles';
var sanitizeHtml = htmlString => {
  var cleanHtmlString = DOMPurify.sanitize(htmlString, {
    USE_PROFILES: {
      html: true
    },
    ADD_ATTR: ['target']
  });
  var wrappedHtmlString = "<div>" + cleanHtmlString + "</div>";
  var html = HTMLReactParser(wrappedHtmlString);
  return html;
};
export var DescriptionWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'DescriptionWidget' : _props$testID,
    style = props.style,
    richText = props.richText,
    _props$disableDefault = props.disableDefaultStyle,
    disableDefaultStyle = _props$disableDefault === void 0 ? false : _props$disableDefault;
  var descriptionWidgetStyles = getDescriptionWidgetStyles();
  return richText && _jsx(View, Object.assign({}, props, {
    style: [!disableDefaultStyle && descriptionWidgetStyles.descriptionContainer, style]
  }, getTestId(testID), {
    children: richText && sanitizeHtml(richText)
  }));
};
DescriptionWidgetComponent.genericRendererKey = 'AirDescriptionWidget';